import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/money-card.svg'
import _imports_1 from '@/assets/icons/blue-money-out.svg'
import _imports_2 from '@/assets/icons/download-icon.svg'
import _imports_3 from '@/assets/icons/empty-transaction-list.svg'


const _withScopeId = n => (_pushScopeId("data-v-06512e10"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-w-full"
}
const _hoisted_2 = {
  key: 1,
  class: "e-wallet-transaction-list"
}
const _hoisted_3 = { class: "e-wallet-money-card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Your Wallet", -1))
const _hoisted_5 = { class: "e-wallet-money" }
const _hoisted_6 = {
  key: 0,
  class: "e-wallet-money-text"
}
const _hoisted_7 = {
  key: 1,
  class: "e-wallet-money-text"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Available Balance", -1))
const _hoisted_9 = { class: "e-wallet-money-out" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_12 = { class: "e-wallet-transaction-list-card" }
const _hoisted_13 = { class: "e-wallet-header" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Transactions", -1))
const _hoisted_15 = { class: "e-wallet-download" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_17 = {
  key: 1,
  class: "download-card"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "download-card-header" }, "Download Statement", -1))
const _hoisted_19 = { class: "download-card-content" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "From", -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "transaction-list__content desktop__wrapper" }
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"transaction-list__first_row\" data-v-06512e10><div class=\"transaction-list__column\" data-v-06512e10><h5 data-v-06512e10>Date</h5></div><div class=\"transaction-list__column\" data-v-06512e10><h5 data-v-06512e10>Time</h5></div><div class=\"transaction-list__column\" data-v-06512e10><h5 data-v-06512e10>Description</h5></div><div class=\"transaction-list__column\" data-v-06512e10><h5 data-v-06512e10>Status</h5></div><div class=\"transaction-list__column\" data-v-06512e10><h5 data-v-06512e10>Amount</h5></div></div>", 1)
const _hoisted_25 = { class: "transaction-list__bottom-content" }
const _hoisted_26 = { class: "transaction-list__column" }
const _hoisted_27 = { class: "transaction-list__column" }
const _hoisted_28 = { class: "transaction-list__column" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "transaction-list__column" }
const _hoisted_31 = { class: "transaction-list__column" }
const _hoisted_32 = { class: "transaction-list__content__item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Date", -1))
const _hoisted_34 = { class: "right__data" }
const _hoisted_35 = { class: "transaction-list__content__item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Time", -1))
const _hoisted_37 = { class: "right__data" }
const _hoisted_38 = { class: "transaction-list__content__item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Description", -1))
const _hoisted_40 = { class: "right__data" }
const _hoisted_41 = { class: "transaction-list__content__item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Status", -1))
const _hoisted_43 = { class: "right__data" }
const _hoisted_44 = { class: "transaction-list__content__item" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Amount", -1))
const _hoisted_46 = { class: "right__data" }
const _hoisted_47 = {
  key: 1,
  class: "e-wallet-transaction-list-empty-card"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty__icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Your e-wallet transactions will show up here.", -1))
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = { key: 2 }
const _hoisted_52 = { class: "transaction-list__content desktop__wrapper" }
const _hoisted_53 = /*#__PURE__*/_createStaticVNode("<div class=\"transaction-list__first_row\" data-v-06512e10><div class=\"transaction-list__column\" data-v-06512e10><h5 data-v-06512e10>Date</h5></div><div class=\"transaction-list__column\" data-v-06512e10><h5 data-v-06512e10>Time</h5></div><div class=\"transaction-list__column\" data-v-06512e10><h5 data-v-06512e10>Description</h5></div><div class=\"transaction-list__column\" data-v-06512e10><h5 data-v-06512e10>Amount</h5></div></div>", 1)
const _hoisted_54 = { class: "transaction-list__bottom-content" }
const _hoisted_55 = { class: "transaction-list__column" }
const _hoisted_56 = { class: "transaction-list__column" }
const _hoisted_57 = { class: "transaction-list__column" }
const _hoisted_58 = { class: "transaction-list__column" }
const _hoisted_59 = { class: "!tw-text-[#FFA500]" }
const _hoisted_60 = { class: "transaction-list__content__item" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Date", -1))
const _hoisted_62 = { class: "right__data" }
const _hoisted_63 = { class: "transaction-list__content__item" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Time", -1))
const _hoisted_65 = { class: "right__data" }
const _hoisted_66 = { class: "transaction-list__content__item" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Description", -1))
const _hoisted_68 = { class: "right__data" }
const _hoisted_69 = { class: "transaction-list__content__item" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Amount", -1))
const _hoisted_71 = { class: "right__data" }
const _hoisted_72 = { class: "!tw-text-[#FFA500]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_MoneyOutModalComponent = _resolveComponent("MoneyOutModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Loader, { show: $setup.isLoading }, null, 8, ["show"])
        ]))
      : _createCommentVNode("", true),
    (!$setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              ($setup.activeUserWorkstation?.name === 'Default')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " £25,000.00 "))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, "£ " + _toDisplayString($setup.availableBalance), 1)),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "e-wallet-money-out-inner-box",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onClickMoneyOut && $setup.onClickMoneyOut(...args)))
              }, [
                _hoisted_10,
                _createTextVNode("MONEY OUT "),
                _hoisted_11
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                ($setup.activeUserWorkstation?.name !== 'Default')
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "button",
                      onClick: $setup.onClickDownload
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16,
                        _createTextVNode("Download")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                ($setup.isShowRange)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode(_component_DatePicker, {
                          modelValue: $setup.dataRange,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.dataRange) = $event)),
                          modelModifiers: { range: true },
                          popover: true
                        }, {
                          default: _withCtx(({ togglePopover, inputValue, inputEvents }) => [
                            _createElementVNode("div", {
                              class: "calendar__select",
                              onClick: () => togglePopover()
                            }, [
                              _createVNode(_component_v_text_field, _mergeProps({
                                value: inputValue.start,
                                variant: "outlined"
                              }, _toHandlers(inputEvents), {
                                placeholder: "Choose Date",
                                class: "date__start input_field",
                                "prepend-inner-icon": "mdi-calendar-text",
                                color: "#0C0F4A"
                              }), null, 16, ["value"]),
                              _createVNode(_component_v_text_field, _mergeProps({
                                value: inputValue.end,
                                variant: "outlined"
                              }, _toHandlers(inputEvents), {
                                placeholder: "Choose Date",
                                class: "date__start",
                                "prepend-inner-icon": "mdi-calendar-text",
                                color: "#0C0F4A"
                              }), null, 16, ["value"])
                            ], 8, _hoisted_21)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_v_btn, {
                          class: "button button-orange",
                          onClick: $setup.onClickDownloadInvoice
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("DOWNLOAD")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (
          $setup.transactionList.length > 0 &&
          $setup.activeUserWorkstation?.name !== 'Default'
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.transactionList, (transaction, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "transaction-list__last_row",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("p", null, _toDisplayString($setup.formatDate(transaction?.transactionDate)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("p", null, _toDisplayString($setup.formatTime(transaction?.transactionDate)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            (transaction?.description)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(transaction?.description), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("p", null, _toDisplayString(transaction?.status || "-"), 1)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("p", {
                              class: _normalizeClass(
                    transaction?.status === 'paid'
                      ? 'text-success'
                      : transaction?.status === 'released'
                      ? 'text-danger'
                      : ''
                  )
                            }, _toDisplayString(transaction?.status === "paid"
                      ? "+"
                      : transaction?.status === "released"
                      ? "-"
                      : "") + "£" + _toDisplayString(transaction?.transactionAmount), 3)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.transactionList, (transaction, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "transaction-list__content mobile__wrapper",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("p", null, _toDisplayString($setup.formatDate(transaction?.transactionDate)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("p", null, _toDisplayString($setup.formatTime(transaction?.transactionDate)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("span", null, _toDisplayString(transaction?.description), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("span", null, _toDisplayString(transaction?.status || "-"), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("p", {
                            class: _normalizeClass(
                  transaction?.status === 'paid'
                    ? 'text-success'
                    : transaction?.status === 'released'
                    ? 'text-danger'
                    : ''
                )
                          }, _toDisplayString(transaction?.status === "paid"
                    ? "+"
                    : transaction?.status === "released"
                    ? "-"
                    : "") + "£" + _toDisplayString(transaction?.transactionAmount), 3)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (
          !$setup.transactionList.length && $setup.activeUserWorkstation?.name !== 'Default'
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_50))
              : _createCommentVNode("", true),
            ($setup.activeUserWorkstation?.name === 'Default')
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("div", _hoisted_54, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.transactionListDummyData, (transaction, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "transaction-list__last_row",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("p", null, _toDisplayString(transaction?.date), 1)
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("p", null, _toDisplayString(transaction?.time), 1)
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("p", null, _toDisplayString(transaction?.description), 1),
                            _createElementVNode("span", null, "Phase " + _toDisplayString(index + 1), 1)
                          ]),
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("p", _hoisted_59, _toDisplayString(transaction?.amount), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.transactionListDummyData, (transaction, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "transaction-list__content mobile__wrapper",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_60, [
                        _hoisted_61,
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("p", null, _toDisplayString(transaction?.date), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _hoisted_64,
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("p", null, _toDisplayString(transaction?.time), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _hoisted_67,
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("p", null, _toDisplayString(transaction?.description), 1),
                          _createElementVNode("span", null, "Phase " + _toDisplayString(index + 1), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _hoisted_70,
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("p", _hoisted_72, _toDisplayString(transaction?.amount), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.isShowMoneyOutModal)
      ? (_openBlock(), _createBlock(_component_MoneyOutModalComponent, {
          key: 2,
          availableBalance: $setup.availableBalance,
          onCloseMoneyOutModal: $setup.onClickCloseButton
        }, null, 8, ["availableBalance", "onCloseMoneyOutModal"]))
      : _createCommentVNode("", true)
  ], 64))
}